"use client";
import React from "react";
import { motion } from "framer-motion";
import styles from "../styles/Services.module.css";


const Services = () => {
  const serviceCategories = [
    {
      title: "Frontend Development",
      description: "Create stunning, lightning-fast user experiences that convert visitors into customers.",
      technologies: [
        {
          name: "Figma",
          icon: '<svg id="12:339" layer-name="Icon" width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="tech-icon" style="width: 27px; height: 27px"> <path d="M10.3333 25.3126C11.5323 25.3126 12.6822 24.8976 13.5301 24.1593C14.3779 23.4209 14.8542 22.4193 14.8542 21.3749V17.4375H10.3333C9.13434 17.4375 7.98446 17.8523 7.13663 18.5907C6.2888 19.3292 5.8125 20.3307 5.8125 21.3749C5.8125 22.4193 6.2888 23.4209 7.13663 24.1593C7.98446 24.8976 9.13434 25.3126 10.3333 25.3126Z" fill="#0ACF83"></path> <path d="M5.8125 13.5C5.8125 12.4557 6.2888 11.4542 7.13663 10.7158C7.98446 9.97736 9.13434 9.5625 10.3333 9.5625H14.8542V17.4374H10.3333C9.13434 17.4374 7.98446 17.0226 7.13663 16.2843C6.2888 15.5458 5.8125 14.5443 5.8125 13.5Z" fill="#A259FF"></path> <path d="M5.8125 5.62501C5.8125 4.58124 6.28831 3.5802 7.13537 2.84185C7.98244 2.10352 9.13142 1.68831 10.3298 1.6875H14.8507V9.56252L10.3333 9.56256C9.13434 9.56256 7.98446 9.14768 7.13663 8.40925C6.2888 7.67082 5.8125 6.6693 5.8125 5.62501Z" fill="#F24E1E"></path> <path d="M14.8545 1.6875H19.3752C20.5744 1.6875 21.7243 2.10234 22.5721 2.84077C23.42 3.5792 23.8962 4.58072 23.8962 5.62501C23.8962 6.6693 23.42 7.67082 22.5721 8.40925C21.7243 9.14768 20.5744 9.56252 19.3752 9.56252L14.8542 9.56256L14.8545 1.6875Z" fill="#FF7262"></path> <path d="M23.8962 13.5C23.8962 14.5443 23.42 15.5459 22.5721 16.2843C21.7243 17.0226 20.5744 17.4376 19.3752 17.4376C18.1763 17.4376 17.0264 17.0226 16.1786 16.2843C15.3308 15.5459 14.8545 14.5443 14.8545 13.5C14.8545 12.4558 15.3308 11.4542 16.1786 10.7158C17.0264 9.97739 18.1763 9.5625 19.3752 9.5625C20.5744 9.5625 21.7243 9.97739 22.5721 10.7158C23.42 11.4542 23.8962 12.4558 23.8962 13.5Z" fill="#1ABCFE"></path> </svg>',
        },
        {
          name: "React JS",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/4e3d2feff4bec8cef345299e88d1f897ec6e01ef",
        },
        {
          name: "Html 5",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/5dcdaa074cee1b91c1caf32664fff0d159da9392",
        },
        {
          name: "Bootstrap",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/1af0fca2697224747df931d8f4fac860ee8c4d79",
        },
        {
          name: "Tailwind CSS",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/08eacf5a52cc5af9a7ed123fb5888836c75ce667",
        },
        {
          name: "Javascript",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/5cab062f4bd346bbbfcb25663ccea4a89724cbc7",
        },
        {
          name: "JQuery",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/154af9411639a9ec481dcaa3bf7f43cde4cb0457",
        },
      ],
    },
    {
      title: "Backend Development",
      description: "Build rock-solid, scalable systems that power your business growth and handle millions of users.",
      technologies: [
        {
          name: "Node JS",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/219068cbf22062fe086ef8eb620a813ebb35b29e",
        },
        {
          name: "Express JS",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/3f6bc0d0f70e3141c3296a61c04626127b22e307",
        },
        {
          name: "PHP",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/e5caf53a2829c94df0f53489839081628180f64a",
        },
        {
          name: "Laravel",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/7d4173b3040340ab0ddbe993a555c1f38e0b47d3",
        },
        {
          name: "Java",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/6d985398c36de96cd70cb409bc77a1bd4470b0a0",
        },
        {
          name: "Spring Boot",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/5cab062f4bd346bbbfcb25663ccea4a89724cbc7",
        },
        {
          name: "MySQL",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/154af9411639a9ec481dcaa3bf7f43cde4cb0457",
        },
      ],
    },
    {
      title: "Mobile Development",
      description: "Launch native mobile apps that users love and can't stop using - iOS, Android, and cross-platform.",
      technologies: [
        {
          name: "React Native",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/4e3d2feff4bec8cef345299e88d1f897ec6e01ef",
        },
        {
          name: "Swift UI",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/27a4fbda1d4b4e48f1039522b86a058189a76651",
        },
        {
          name: "Kotlin",
          icon: '<svg id="20:13" layer-name="kotlin-seeklogo 1" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="tech-icon" style="width: 27px; height: 27px"> <g clip-path="url(#clip0_20_13)"> <path d="M0 27.0001L13.545 13.4551L27 27.0001H0Z" fill="url(#paint0_linear_20_13)"></path> <path d="M0 0H13.545L0 14.625V0Z" fill="url(#paint1_linear_20_13)"></path> <path d="M13.545 0L0 14.265V27L13.545 13.455L27 0H13.545Z" fill="url(#paint2_linear_20_13)"></path> </g> <defs> <linearGradient id="paint0_linear_20_13" x1="718.173" y1="1998.6" x2="1096.07" y2="497.029" gradientUnits="userSpaceOnUse"> <stop offset="0.09677" stop-color="#0095D5"></stop> <stop offset="0.3007" stop-color="#238AD9"></stop> <stop offset="0.6211" stop-color="#557BDE"></stop> <stop offset="0.8643" stop-color="#7472E2"></stop> <stop offset="1" stop-color="#806EE3"></stop> </linearGradient> <linearGradient id="paint1_linear_20_13" x1="189.414" y1="542.66" x2="982.38" y2="-137.512" gradientUnits="userSpaceOnUse"> <stop offset="0.1183" stop-color="#0095D5"></stop> <stop offset="0.4178" stop-color="#3C83DC"></stop> <stop offset="0.6962" stop-color="#6D74E1"></stop> <stop offset="0.8333" stop-color="#806EE3"></stop> </linearGradient> <linearGradient id="paint2_linear_20_13" x1="-454.576" y1="2482.37" x2="2057.92" y2="-30.123" gradientUnits="userSpaceOnUse"> <stop offset="0.1075" stop-color="#C757BC"></stop> <stop offset="0.2138" stop-color="#D0609A"></stop> <stop offset="0.4254" stop-color="#E1725C"></stop> <stop offset="0.6048" stop-color="#EE7E2F"></stop> <stop offset="0.743" stop-color="#F58613"></stop> <stop offset="0.8232" stop-color="#F88909"></stop> </linearGradient> <clipPath id="clip0_20_13"> <rect width="27" height="27" fill="white"></rect> </clipPath> </defs> </svg>',
        },
      ],
    },
    {
      title: "Content Management Systems (CMS)",
      description: "Manage your content effortlessly with powerful, user-friendly platforms that grow with your business.",
      technologies: [
        {
          name: "Wordpress",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/469040e8e97971b6a13fd549ebc8ce1bf466c2a1",
        },
        {
          name: "Wix",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/35ce5223e5f9aaa14c0304b1dd43a229167fb06e",
        },
        {
          name: "Shopify",
          icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/ded625a1e9c00d98d6ebb1bd13fe653611d034bd",
        },
        {
          name: "Data Analytics",
          icon: '<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="tech-icon" style="width: 27px; height: 27px"><path d="M3 21V15M9 21V9M15 21V3M21 21V12" stroke="#6366F1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="3" cy="15" r="2" fill="#6366F1"/><circle cx="9" cy="9" r="2" fill="#6366F1"/><circle cx="15" cy="3" r="2" fill="#6366F1"/><circle cx="21" cy="12" r="2" fill="#6366F1"/></svg>',
        },
      ],
    },
  ];

  return (
    <div className={styles.servicesContainer}>
      <motion.div
        className={styles.servicesHeader}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.7 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        <div className={styles.heading}>🚀 Our Digital Arsenal</div>
        <div className={styles.description}>
          From pixel-perfect frontends to bulletproof backends, we craft digital solutions that don't just work—they dominate. 
          Every technology chosen for maximum impact and scalability.
        </div>
      </motion.div>
      <motion.div
        className={styles.servicesGrid}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.18
            }
          }
        }}
      >
        {serviceCategories.map((category, index) => (
          <motion.div
            className={styles.serviceCard}
            key={index}
            variants={{
              hidden: { opacity: 0, y: 40 },
              visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } }
            }}
          >
            <div className={styles.serviceHeader}>
              <div className={styles.serviceTitle}>{category.title}</div>
              <div className={styles.serviceDescription}>
                {category.description}
              </div>
            </div>
            <div className={styles.technologiesList}>
              {category.technologies.map((tech, techIndex) => (
                <div className={styles.technologyItem} key={techIndex}>
                  {tech.icon.startsWith("<") ? (
                    <div
                      className={styles.iconWrapper}
                      dangerouslySetInnerHTML={{ __html: tech.icon }}
                    />
                  ) : (
                    <img
                      src={tech.icon}
                      alt={tech.name}
                      className={styles.techIcon}
                      loading="lazy"
                    />
                  )}
                  <span>{tech.name}</span>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default Services;
